import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuditLogService } from '../audit-log.service';
import { LocalStorageService } from '../localstorage.service';
import { environment } from 'environments/environment';
import { BaseService } from '../incomeTaxBase.service';
import { LoggedInUserDto } from 'app/shared/modals/dashboard/loggedInUserDto';

@Injectable()
export class AuthService {
  baseUrl: string = environment.apiUrlV1
  
  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private auditLogService: AuditLogService,
    private baseService: BaseService
  ) { }

  Login(body: string, headers?: HttpHeaders): Observable<LoggedInUserDto> {
    return this.baseService.postApi<LoggedInUserDto>('Auth/Login', body, headers);
  }

  isAuthenticated(): boolean {
    return true;
  }

}
